module.exports = "img/check.svg";